// import { logger as Logger } from '@core/util/universal-logger/server-side-launcher';

// ### Description
// Cookie utility class for managing cookies
// consolidate/cleanup cookie functionality
// http://www1.macys.com/javascript/cookieJar.js (/**DO NOT USE THIS FILE!  Use MACYS.util.Cookie instead! */   ) and
// http://www1.macys.com/web20/assets/script/macys/./cookie-min.js
// and http://www1.macys.com/web20/assets/script/yahoo/cookie/cookie-beta-min.js
// and http://www1.macys.com/web20/assets/script/macys/base/cmFunctions.js
// cookie and store up to 4K
// Group cookies; decrease time to access groups in cookie
// macys.com cookie reference on confluence
// http://confluence/display/WDS/current+macys+cookies

module.exports = class Cookie {
  static MVC_SEPARATOR = '3_87_';

  static MVC_EQUATOR = '1_92_';

  static MVC_EMPTY_STRING = '4_02_';

  static path = '/';

  /**
   * parse cookieString for cookieName
   * @param {string} [optional] cookieString the cookie string to parse
   * @param {string} cookieName Used with disableDecoding, used to disableDecoding for cookieName
   * @param {boolean} [optional] disableDecoding Indicates if the cookie values should be decoded or not
   * @returns cookie key value
   * parse document.cookie if cookieString not available
   */
  static parse = (cookieString, cookieName, disableDecoding) => {
    let j;
    const rmap = {};
    let cparts;
    let cname;
    let cvalue;

    if (typeof cookieString === 'object' && !Array.isArray(cookieString) && cookieString !== null) {
      return cookieString;// this is an object
    }
    const dc = cookieString || ((Cookie.#hasDocumentCookie()) ? document.cookie : undefined);
    if (!dc) {
      return rmap;
    }
    const cookies = dc.split(/;\s/g);
    const clen = cookies.length;
    // put all cookies in an object
    for (j = 0; j < clen; j += 1) {
      cparts = cookies[j].match(/([^=]+)=/i);
      try {
        if (cparts instanceof Array) {
          cname = decodeURIComponent(cparts[1]);
          if (cname === cookieName && disableDecoding) {
            cvalue = cookies[j].substring(cparts[1].length + 1);
          } else {
            cvalue = decodeURIComponent(cookies[j].substring(cparts[1].length + 1));
          }
        } else {
          cname = decodeURIComponent(cookies[j]);
          cvalue = '';
        }
        rmap[cname.replace(/ /g, '')] = cvalue;
      } catch (e) {
        // ignore it.
        // Logger.warn('Error happened while parsing cookie string: ', cookies[j], e);
      }
    }
    return rmap;
  }

  /**
   * get cookie value from document.cookie
   * @param {string} name the name of the cookie to get
   * @param {string} [optional] multiValueCookie
   * @param {boolean} [optional] disableDecoding
   * @returns {string} the cookie value
   * This method ONLY works on document.cookie
   */
  static get = (name, multiValueCookie, disableDecoding) => {
    let result;
    let mvcParts;
    let plen;
    let j;
    let items;
    // hash will always be an object but may not have props
    const hash = Cookie.parse(undefined, name, disableDecoding);
    if (typeof multiValueCookie !== 'undefined') {
      if (hash[multiValueCookie]) {
        mvcParts = hash[multiValueCookie].split(Cookie.MVC_SEPARATOR);
        plen = mvcParts.length;
        for (j = 0; j < plen; j += 1) {
          items = mvcParts[j].split(Cookie.MVC_EQUATOR);
          if (items[0] === name) {
            result = items[1] === Cookie.MVC_EMPTY_STRING ? '' : items[1];
            break;
          }
        }
      }
    } else {
      result = hash[name];
    }
    return result;
  }

  /**
   * formatDomainForCookie
   * @param {string} host
   * @return {string} standard cookie domain values
   * Will format a string to standard cookie domain values.  In particular, will take in string.  If none is passed in
   * then will attempt to pull domain value from configuration.
   * If it is passed in, then it will first check for at least two dots, and if found, return wild carded domain.
   */
   static formatDomainForCookie = (host) => {
     let domain;
     let globalsBaseHost;
     if (typeof host === 'string' && host.length > 0) {
       if (host.indexOf('.', host.indexOf('.', 0) + 1) > 1) {
         domain = host.indexOf('.', 0) > 0 ? host.substring(host.indexOf('.', 0)) : host;
       } else {
         domain = '';
       }
     } else {
       globalsBaseHost = process.env.COOKIE_DOMAIN;
       domain = typeof globalsBaseHost !== 'undefined' ? globalsBaseHost : undefined;
       if (typeof domain === 'undefined' || domain === null) {
         domain = Cookie.getHostName().replace(/(^(m|www[1]?))\./gi, '');
       }
     }
     // remove port for local testing
     domain = domain && domain.indexOf(':') !== -1 ? domain.substring(0, domain.indexOf(':')) : domain;
     return domain;
   }

  /**
   * getHostName
   * @return {string} window.location.hostname
   */
  static getHostName = () => window.location.hostname

  /**
   * set name,val in cookie
   * @param {string} name of the cookie to set
   * @param {string} val of the cookie to set
   * @param {string} [optional] multiValueCookie
   * @param {Date, object} options [optional]
   * >options example: {expires: expiryDate, path: "/signin", domain: "fds.com", secure: true}
   */
   static buildMVCValue = (multiValueCookie, name, value) => {
     let mvcSubs;
     let j;
     let resultValue;
     let slen;
     let pairs;
     // get the whole multi value cookie
     const mvcValue = Cookie.get(multiValueCookie);
     const subCookie = name + Cookie.MVC_EQUATOR + (value === '' ? Cookie.MVC_SEPARATOR : value);
     if (!mvcValue || mvcValue === null) {
       // no cookie with the multiValueCookie name
       resultValue = subCookie;
     } else if (mvcValue.indexOf(name) === -1) {
       // multiValueCookie exists but the name value pair we want does not
       resultValue = mvcValue + Cookie.MVC_SEPARATOR + subCookie;
     } else {
       // multiValueCookie exists and there is a sub cookie with that name
       mvcSubs = mvcValue.split(Cookie.MVC_SEPARATOR);
       slen = mvcSubs.length;
       for (j = 0; j < slen; j += 1) {
         pairs = mvcSubs[j].split(Cookie.MVC_EQUATOR);
         if (pairs[0] === name) {
           mvcSubs[j] = name + Cookie.MVC_EQUATOR + value;
         }
       }
       resultValue = mvcSubs.join(Cookie.MVC_SEPARATOR);
     }
     return resultValue;
   }

   /**
   * set name,val in cookie
   * If multiValueCookie is provided, set as part of multiValueCookie
   * @param {string} name of the cookie to set
   * @param {string} val of the cookie to set
   * @param {string} [optional] multiValueCookie
   * @param {Date, object} options [optional]
   * >options example: {expires: expiryDate, path: "/signin", domain: "fds.com", secure: true}
   */
   static set = (name, val, multiValueCookie, options) => {
     let value = val;
     let data;
     let encodeValue;
     let setName = name;
     let localSecure;
     let localExpires;
     let localPath = Cookie.path;
     const sameSite = 'Lax';
     let optionsSameSiteValue;
     value = typeof value === 'boolean' ? value.toString() : value;
     if (typeof value === 'undefined' || value === null) {
       if (!multiValueCookie) {
         return false;
       }
       // mvc cookie can have undefined or null value but it should be set to this
       value = Cookie.MVC_EMPTY_STRING;
     }

     encodeValue = value;
     if (multiValueCookie) {
       setName = multiValueCookie;
       if (value === '') {
         value = Cookie.MVC_EMPTY_STRING;
       }
       encodeValue = Cookie.buildMVCValue(multiValueCookie, name, value);
     }

     data = `${encodeURIComponent(setName)}=${encodeURIComponent(encodeValue)}`;

     if (options) {
       if (options.expires) {
         localExpires = options.expires;
       }
       if (localExpires && localExpires.constructor === Date) {
         localExpires = localExpires.toUTCString();
       }
       if (options.path) {
         localPath = options.path;
       }
       if (options.secure !== undefined) {
         localSecure = options.secure;
       }
       optionsSameSiteValue = options.sameSite;
     }
     data += `; path=${localPath}`;

     if (localExpires) {
       data += `; expires=${localExpires};`;
     }
     if (localSecure === undefined) {
       localSecure = true;
     }

     const domain = Cookie.formatDomainForCookie(options ? options.domain || '' : '');
     if (domain && domain.length) {
       data += `; domain=${domain}`;
     }
     if (localSecure) {
       data += ` ;secure=${localSecure}`;
     }

     // by default setting samesite attribute as Lax
     // if samesite is already set then setting the same value or else setting as lax
     // some Browsers dont support 'None' as value - esp Safari 13 in Mojave and previous,
     // for those cases , in UI , sameSite value is used as 'NoValue'
     if (optionsSameSiteValue !== 'NoValue') {
       data += `; SameSite=${optionsSameSiteValue || sameSite}`;
     }
     if (Cookie.#hasDocumentCookie()) {
       document.cookie = data;
       return true;
     }

     return false;
   }

   /**
   * remove cookie
   * @param {string} name of the cookie to remove
   * @param {string} [optional] multiValueCookie
   */
   static remove = (name, multiValueCookie, options) => {
     let mvcValue;
     let mvcSubs;
     let newValue;
     let j;
     let mvcParts;
     const expiresValue = 'Thu, 01 Jan 1970 00:00:01 GMT';
     const expiredOptions = {
       ...options,
       expires: expiresValue,
     };
     if (multiValueCookie) {
       mvcValue = Cookie.get(multiValueCookie);
       if (mvcValue && mvcValue.indexOf(name) !== -1) {
         mvcSubs = mvcValue.split(Cookie.MVC_SEPARATOR);
         newValue = '';
         for (j = 0; j < mvcSubs.length; j += 1) {
           mvcParts = mvcSubs[j].split(Cookie.MVC_EQUATOR);
           if (mvcParts[0] !== name) {
             if (newValue !== '') {
               newValue += Cookie.MVC_SEPARATOR;
             }
             newValue += mvcSubs[j];
           }
         }
         Cookie.set(multiValueCookie, newValue, undefined, expiredOptions);
       }
     } else {
       Cookie.set(name, '', undefined, expiredOptions);
     }
   }

   /**
   * getCountryCode
   * @return {string} country code for shipping
   */
    static getCountryCode = () => {
      let countryCode = Cookie.get('shippingCountry');
      if (!countryCode) {
        countryCode = null;
      }

      return countryCode;
    }

    /**
   * getCurrencyCode
   * @return {string} currency code
   */
    static getCurrencyCode = () => {
      let currencyCode = Cookie.get('currency');
      if (!currencyCode) {
        currencyCode = null;
      }

      return currencyCode;
    }

    /**
   * isInternationalMode
   * @return {boolean} Is shippingCountry outside of US
   */
   static isInternationalMode = () => {
     let isInternational = false;
     const shippingCountry = Cookie.getCountryCode();
     if (shippingCountry) {
       isInternational = shippingCountry !== 'US';
     }

     return isInternational;
   }

   /**
   * getSessionId
   * @return {string} Customer Online UID if exsits or 0000000000 for testing purpose
   */
   static getSessionId = () => {
     const sessionId = Cookie.get('bloomingdales_online_uid') || Cookie.get('macys_online_uid') || '0000000000';
     return sessionId;
   }

   /**
   * getUserZipCode
   * @returns {string} user selected zipcode from MISCGCs cookie
   */
   static getUserZipCode = () => Cookie.get('USERPC', 'MISCGCs')

   /*
   * get device type from cookie object
   * Private function - do not expose
   */
  static getDeviceTypeFromCookie = (cookie) => this.getMultiValueCookie('DT', 'MISCGCs', cookie)

  /*
   * get shipping country from cookie object
   * Private function - do not expose
   */
  static getShippingCountryFromCookie = (cookie) => {
    let shippingCountry;
    if (cookie && cookie.shippingCountry !== undefined) {
      ({ shippingCountry } = cookie);
    }
    return shippingCountry;
  }

  /*
   * get user status from request
   * @param {object} req
   * Private function - do not expose
   */
  static getUserStatusFromCookie = (cookie = {}) => ({
    getUserName() {
      return Cookie.getMultiValueCookie('UserName', 'MISCGCs', cookie);
    },
    isSignedIn() {
      return cookie.SignedIn === '1';
    },
    isSoftSignedIn() {
      return Cookie.getMultiValueCookie('UserName', 'MISCGCs', cookie) && !this.isSignedIn(cookie);
    },
    isNewSoftSignedIn() {
      return Cookie.isSoftSignedIn();
    },
    getUserTokenForHeaders() {
      return {
        guid: cookie.macys_online_guid,
        uid: cookie.macys_online_uid,
        secureToken: cookie.secure_user_token,
      };
    },
  })

  /**
   * get cookie type and parse to object if string
   * @param {string} cookie
   * @param {object} cookie
   * @returns {object} cookie
   */
  static getCookieObject = (cookie) => {
    if (typeof cookie === 'string') {
      return Cookie.parse(cookie);
    }
    return cookie;
  }

  /*
   * get user details from cookie object
   */
  static getUserDetailsFromCookie = (cookie) => {
    const cookieObj = Cookie.getCookieObject(cookie);
    const UserDetail = Cookie.getUserStatusFromCookie(cookieObj);
    return UserDetail.getUserTokenForHeaders();
  };

  /*
   * get customer state from cookie object
   * Private function - do not expose
   */
  static getCustomerStateFromCookie = (cookie) => {
    const cookieObj = Cookie.getCookieObject(cookie);
    const UserStatus = Cookie.getUserStatusFromCookie(cookieObj);
    if (UserStatus.isSignedIn()) {
      return 'SIGNED_IN';
    } if (UserStatus.isSoftSignedIn()) {
      return 'RECOGNIZED';
    }

    return 'GUEST';
  };

  /**
   * gets CurrentStoreLocation from cookie object
   * SFL Save For Later
   */
  static getCurrentStoreLocationFromCookie = (cookies) => {
    let storeLocation = Cookie.getMultiValueCookie('STRL', 'CSL', cookies);
    if (!storeLocation) {
      storeLocation = Cookie.getMultiValueCookie('CSL', undefined, cookies);
    }
    return storeLocation;
  };

   /**
   * get cookie value from cookie object
   * @param {string} name
   * @param {string} multiValueCookie
   * @param {object} cookie, the cookie object
   * @returns
   * Placed inline because current cookie library is AMD
   */
   static getMultiValueCookie = (name, multiValueCookie, cookie) => {
     let result;
     let mvcParts;
     let plen;
     let j;
     let items;
     const MVC_SEPARATOR = '3_87_';
     const MVC_EQUATOR = '1_92_';
     const MVC_EMPTY_STRING = '4_02_';
     if (!cookie) {
       return undefined;
     }
     if (typeof multiValueCookie !== 'undefined') {
       if (cookie[multiValueCookie]) {
         mvcParts = cookie[multiValueCookie].split(MVC_SEPARATOR);
         plen = mvcParts.length;
         for (j = 0; j < plen; j += 1) {
           items = mvcParts[j].split(MVC_EQUATOR);
           if (items[0] === name) {
             result = items[1] === MVC_EMPTY_STRING ? '' : items[1];
             break;
           }
         }
       }
     } else {
       result = cookie[name];
     }
     return result;
   };

   // Can we get/set cookies on document.cookie?
   static #hasDocumentCookie = () => typeof document === 'object' && typeof document.cookie === 'string'
};
